import { LitElement, html } from 'lit';
import { dispatchEvent } from '@fil-global/shared/src/util';

import componentStyles from './fil-modal-heading.styles.js';

/**
 * @tag fil-modal-heading
 * @property {object} [icon] customize the icon color and size
 */
export class FilModalHeading extends LitElement {
  static properties = {
    icon: { type: Object },
  };

  static styles = [componentStyles];

  constructor() {
    super();
    this.icon = { color: 'blue-500', size: 64 };
  }

  slotChangeHandler() {
    const slot = this.shadowRoot.querySelector('slot');
    const iconElements =
      slot
        ?.assignedElements()
        .filter(node => /^fil-icon-|fil-pictogram-/.test(node.tagName.toLowerCase())) || [];
    if (iconElements.length > 0) {
      const slotIcon = iconElements[0];
      const color = slotIcon.getAttribute('color') || this.icon.color;
      const size = slotIcon.getAttribute('size') || this.icon.size;

      slotIcon.setAttribute('color', color);
      slotIcon.setAttribute('size', size);
      slotIcon.classList.add('fil-modal__icon');
      this.setAttribute('hasIcon', true);
      this.setAttribute('alignment', 'center');
      this.dispatchModalEvent(slotIcon.tagName);
    } else {
      // no icon and no image in content
      if (this.getAttribute('hasIcon') === 'true' && this.getAttribute('alignment') === 'center') {
        this.setAttribute('alignment', '');
      }
      this.setAttribute('hasIcon', false);
      this.dispatchModalEvent('');
    }
  }

  dispatchModalEvent(value) {
    dispatchEvent(this, 'has-image.gds.modal', { value, name: 'heading' });
  }

  render() {
    return html`<slot @slotchange=${this.slotChangeHandler}></slot>`;
  }
}

export default FilModalHeading;
